
define('jsx!components/login-private-tenant',[
	"react",
	"jsx!components/login-private-tenant/divider-or",
	"jsx!components/login-public-tenant/input-username",
	"jsx!components/login-public-tenant/input-password",
	"jsx!components/shared/login-image-picker",
	"jsx!components/login-public-tenant/button-sign-in",
	"shared/client"
], function (React, DividerOrComponent, UsernameComponent, PasswordComponent, AuthImagePickerComponent, SignInButton, Client) {

	return React.createClass({
		displayName: "LoginPrivateTenant",
		clearMessageTimeout: null,
		getDefaultProps: function ()
		{
			return {
				"tenant": {},
				"message": null,
				"api_url": ""
			}
		},
		getInitialState: function ()
		{	
			this.resetClearmessageTimeout();
			localStorage.removeItem('teams-meeting');
			return {
				"username": null,
				"password": null,
				"show_password_input": false,
				"validating": false,
				"authentication_method": null,
				"message": this.props.message || null,
				"request_in_progress": false,
				"image_set": [],
				"show_auth_image_picker" : false
			}
		},
		resetClearmessageTimeout: function() {
			var self = this;
			if(this.clearMessageTimeout) {
				window.clearTimeout(this.clearMessageTimeout);
			}
			this.clearMessageTimeout = window.setTimeout(function () {
				self.setState({
					message: null
				});
				self.clearMessageTimeout = null;
			}, 10000);
		},
		setMessage: function(message) {
			this.resetClearmessageTimeout();
			this.setState({
				"message": message
			});
		},
		setUsername: function (v)
		{
			this.setState({
				"username": v
			});
		},
		setPassword: function (v)
		{
			this.setState({
				"password": v
			});
		},
		setAuthenticationMethod: function (v)
		{
			this.setState({
				"authentication_method": v
			});
		},
		handleEnterKeyUp: function ()
		{
			this.handleClickOnSignInButton();
		},
		handleClickOnSignInButton: function ()
		{
			if(this.state.validating) {
				return;
			}
			try {
				if (this.state.username !== null && this.state.show_password_input === false && this.state.authentication_method === null) {
					this.setValidating(true);

					const validUsername = new RegExp(/^[\p{L}0-9!#$%&*\\'+^?`{}|~@_\.\-\/]+$/iu);
					if (!validUsername.test(this.state.username)) {
						throw new Error("Username contains an invalid character.");
					}

					if (!this.state.username) {
						throw new Error("Please enter a username.");
					}

					if (this.state.authentication_method === "password" && this.state.show_password_input && this.state.password <= 0) {
						throw new Error("Please enter a password.");
					}

					if (this.state.authentication_method === "image_set" &&  this.state.show_auth_image_picker && this.state.image_set.length < 2) {
						throw new Error("Please select two images.");
					}

					this.validateUsernameExists();

				} else if (this.state.username !== null && this.state.authentication_method !== null) {
					var authValue = this.state.authentication_method === "image_set" ? this.state.image_set : this.state.password;
					this.executeSignInRequest(this.state.username, this.state.authentication_method, authValue);
				}
			} catch (e) {
				this.setMessage(e.message || "Failed to execute login request");
			}
		},
		validateUsernameExists: function ()
		{
			// add this to helper? Might not be too helpful
			var self = this;
			var requestId = Date.now();
			this.validationRequestId = requestId;

			$.get(window.appData.client.api_url + "/users/exists", {
				"username": this.state.username
			})
			.done(function (response) {
				if (self.validationRequestId !== requestId) {
					return;
				}

				/*
				 * If the user has been deleted, let them know.
				 */
				if (typeof response.data.deleted_at === "string") {
					self.setState({
						"message": "This account has been deactivated."
					});
					return;
				}

				self.setState({
					"message": null
				});

				/*
				 * If the user can be authenticated via image-set login.
				 * let the parent component know.
				 */
				if (response.data.supports_image_set_auth) {
					self.setState({
						"password": null
					});
					self.setAuthenticationMethod("image_set");
				} else {
					self.setAuthenticationMethod("password");
				}
			})
			.fail(function (jqXHR) {
				if (self.validationRequestId !== requestId) {
					return;
				}
			})
			.always(function () {
				
				self.setValidating(false);
				self.setUsername(self.state.username);
				self.validationRequestId = null;
				self.state.authentication_method === "image_set" ? self.showAuthImagePicker() : self.showPasswordInput();
			});
		},
		executeSignInRequest: function (username, authentication_method, authentication_value)
		{
			var self = this;

			if (this.state.request_in_progress) {
				return false;
			}

			this.setState({
				"message": null,
				"request_in_progress": true
			});

			var returnTo  = window.appData.request.query.return_to;

			return $.post("/login", {
				"username": username,
				"authentication_method": authentication_method || "password",
				"authentication_value": authentication_value,
				"return_to": returnTo ? returnTo : ""
			})
			.done(function (response) {
				window.location = response.redirect_to;
			})
			.fail(function (jqXHR) {
				if ((jqXHR.responseText || "").indexOf("credentials were incorrect") > -1) {
					self.setMessage("The username or password you entered is incorrect");
				} else if (jqXHR.responseText.indexOf("The username format is invalid.") > -1) {
					self.setMessage("The username contains an invalid character.");
				}  else if (jqXHR.responseText.indexOf("The authentication value field is required when authentication method is present") > -1) {
					self.setMessage("Password cannot be empty");
				} else {
					self.setMessage(jqXHR.responseText || "Failed to execute log in request");
				}
			})
			.always(function () {
				self.setState({ "request_in_progress": false });
			});
		},
		componentDidUpdate: function (prevProps, prevState)
		{
			var self = this;

			/*
			 * If we are authenticated via image_set and just clicked
			 * the second image, auto-login.
			 */
			if (self.state.authentication_method === "image_set") {
				if (prevState.image_set.length == 1 && self.state.image_set.length == 2) {
						// We execute the login using the image titles, not the whole object.
						var authValue = self.state.image_set.map(function (image) {
							return image.title
						});

						var promise = self.executeSignInRequest(
							self.state.username,
							"image_set",
							authValue
						);

						promise.fail(function (jqXHR) {
							self.setState({ "image_set": [] }, function () {
								if (jqXHR.status === 403 || (jqXHR.responseText || "").indexOf("more failed attempt") > -1) {
									self.setMessage(jqXHR.responseText || "Failed to execute log in request");
								} else {
									self.setMessage("Oops, that's not it, try again!");
								}
							});
						});
				}

				/*
				 * If we clicked a new image, hide the error message on the auth picker.
				 */
				if (!(prevState.image_set === self.state.image_set)) {
					self.setState({ "message": null });
				}
			}

			// Should we show the activity modal?
			if (!prevState.request_in_progress && self.state.request_in_progress === true) {
				self.showActivityModal();
			} else if (!self.state.request_in_progress && prevState.request_in_progress === true) {
				self.hideActivityModal();
			}
		},
		showActivityModal: function ()
		{
			if($('#activity-modal').length > 0) {
				$('#activity-modal').modal({
					"keyboard": false,
					"backdrop": "static"
				});
			}
			
		},
		hideActivityModal: function ()
		{
			if($('#activity-modal').length > 0) {
				$('#activity-modal').modal('hide');	
			}
		},
		renderAuthImagePicker: function ()
		{
			var self = this;

			return (
				React.createElement("div", {className: "modal-wrapper"}, 
					React.createElement("div", {className: "overlay"}), 
					React.createElement("div", {className: "modal modal-auth-image-picker"}, 

						React.createElement("h2", null, "Select Your Password Images"), 
						 this.renderErrorMessage(), 

						React.createElement(AuthImagePickerComponent, {
							disabled:  this.state.request_in_progress, 
							selected_images:  self.state.image_set, 
							onChange:  function (selected_images) {
								self.setState({ image_set: selected_images });
							}}), 

						React.createElement("button", {className: "btn-close", onClick:  function () {
							// Reset the login form
							self.setState({
								"image_set": [],
								"show_auth_image_picker" : false,
								"authentication_method": null
							});
						}, "aria-label": "close"}, 
							React.createElement("span", {className: "dashboard-icon-close"})
	                    )

					)
				)
			);
		},
		renderErrorMessage: function ()
		{	
			if (!(typeof this.state.message === "string")) {
				return null;
			}

			return (
				React.createElement("div", {className: "error bg-danger text-danger"}, 
					 this.state.message
				)
			);
		},
		renderLoginForManual: function ()
		{
			var self = this;

			return (
				React.createElement("div", {id: "login-form"}, 
					React.createElement(UsernameComponent, {
						username: this.state.username, 
						setUsername: this.setUsername, 
						setAuthenticationMethod: this.setAuthenticationMethod, 
						setErrorMessage: this.setMessage, 
						handleEnterKeyUp: this.handleEnterKeyUp, 
						hidePasswordInput: this.hidePasswordInput}
						), 
					
					
						this.state.authentication_method !== "image_set" && this.state.show_password_input ? 
						React.createElement(PasswordComponent, {
							password: this.state.password, 
							setPassword: this.setPassword, 
							handleEnterKeyUp: this.handleEnterKeyUp}) :
						null, 
					

					
						// Show the auth image picker
						this.state.show_auth_image_picker
						&& this.renderAuthImagePicker(), 
					
					
					React.createElement(SignInButton, {	
						username: this.state.username, 
						password: this.state.password, 
						validating: this.state.validating, 
						onClick: this.handleClickOnSignInButton}), 
					React.createElement("a", {href: "/reset-password"}, "Forgot your password?")
				)
			);
		},
		renderLoginForGoogle: function ()
		{
			return (
				React.createElement("div", null, 
					
					React.createElement("a", {href:  this.props.api_url + "/login/external/google"}, 
						React.createElement("img", {src: "/images/btn-google-signin-normal.png", width: "300", className: "btn-google", alt: "Google sign-in button"})
					), 
					React.createElement(DividerOrComponent, null), 
					 this.renderLoginForManual() 
				)
			);
		},
		renderLoginForMicrosoft: function ()
		{
			return (
				React.createElement("div", null, 
					React.createElement("a", {href:  this.props.api_url + "/login/external/microsoft"}, 
						React.createElement("button", {className: "btn btn-microsoft", id: "btn-sign-in-microsoft"}, 
							"Sign In with Microsoft"
						)
					), 
					React.createElement(DividerOrComponent, null), 
					 this.renderLoginForManual() 
				)
			);
		},
		renderLoginForClever: function ()
		{
			return (
				React.createElement("div", null, 
					
					React.createElement("a", {href:  this.props.api_url + "/login/external/clever"}, 
						React.createElement("button", {className: "btn btn-clever", id: "btn-sign-in-clever"}, 
							"Sign In with Clever"
						)
					), 
					React.createElement(DividerOrComponent, null), 
					 this.renderLoginForManual() 
				)
			);
		},
		renderLoginForClassLink: function ()
		{
			return (
				React.createElement("div", null, 
					
					React.createElement("a", {href:  this.props.api_url + "/login/external/classlink"}, 
						React.createElement("img", {src: "/images/classlink-login-button-large.png", width: "300", className: "btn-classlink", alt: "Google sign-in button"})
					), 
					React.createElement(DividerOrComponent, null), 
					 this.renderLoginForManual() 
				)
			);
		},
		showPasswordInput: function() {
			this.setState({
				show_password_input: true,
			})
		},
		hidePasswordInput: function() {
			this.setState({
				show_password_input: false,
				authentication_method: null
			})
		},
		setValidating: function(validating) {
			this.setState({
				validating: validating,
				show_password_input: false
			})
		},
		showAuthImagePicker: function() {
			this.setState({
				show_auth_image_picker: true
			})
		},
		render: function ()
		{
			return (
				React.createElement("div", {className: "container"}, 
					React.createElement("div", {className: "row"}, 
						React.createElement("div", {className: "col-lg-12"}, 
							React.createElement("img", {
								style: {width: "100%", display:"block", margin:"0 auto 20px auto", borderRadius: "25px", cursor: "pointer"}, 
								src:  Client.assetURL('/images/login/main_1_byCapstone.gif') }
							), 

							React.createElement("div", {className: "client-label"},  this.props.tenant.name), 

							 this.renderErrorMessage(), 

							
								this.props.tenant.sync_strategy === "clever" && 
								this.renderLoginForClever(), 
							

							
								this.props.tenant.sync_strategy === "classlink" && 
								this.renderLoginForClassLink(), 
							

							
								this.props.tenant.sync_strategy === "google" && 
								this.renderLoginForGoogle(), 
							

							
								this.props.tenant.sync_strategy === "microsoft" && 
								this.renderLoginForMicrosoft(), 
							

							
								this.props.tenant.sync_strategy === "manual" && 
								this.renderLoginForManual()
							

						)
					)
				)
			);
		}
	});

});
